import React from "react";
import { COLORS } from "../../theme";
import Spinner from "./Spinner";

// Substitui o "Carregando..." de texto puro que se repetia em toda tela com
// lista/tabela — mesmo padding/cor de antes, só com um spinner na frente.
export default function EstadoCarregando({ texto = "Carregando...", padding = 24 }) {
  return (
    <div style={{ padding, display: "flex", alignItems: "center", gap: 10, fontSize: 13.5, color: COLORS.textMid }}>
      <Spinner size={15} />
      {texto}
    </div>
  );
}
